import {ICompanySyncstep, IExportAttribute, IExportFlow, IMessageData, IObjectType, IRuleset} from "../../../../index";
import {IExportFlowMutable, IExportTemplateMutable} from "../../index";
import {global} from "../../../../appContext";
import {nsExportTemplate} from "../../fn";
import {IParams} from "./index";
import {KOSubscriptionTracker} from "../../../../util/KOSubscriptionTracker";
import {nsRoute} from "../../../../util/route";
import {Mutable} from "../../mutable";
import {ObjectTypeId} from "../../../../constants";
import * as ko from "knockout";
import {nsRule} from "../../../ruleset/mutable/rule/nsRule";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import MutableAbstractHtml from './MutableAbstract.html?raw';

export let template = MutableAbstractHtml;

export const CustomLabel = 'custom';

export abstract class MutableAbstract extends ParsedRouteDataDecorator {
    private InputMode = nsRule.InputMode
    private readonly ObjectTypeId = ObjectTypeId;
    protected exportAttributes!: IExportAttribute[];
    protected readonly _data: KnockoutObservableArray<IExportFlowMutable>;
    protected readonly abstract type: 'export' | 'import';
    protected readonly exporttemplate: IExportTemplateMutable;
    protected readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    protected readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    protected readonly mutable: Mutable;
    protected readonly objecttype: KnockoutObservable<IObjectType | null>;
    protected readonly rulesets: IRuleset[];
    protected readonly syncstep: KnockoutObservable<ICompanySyncstep | null>;

    constructor(params: IParams) {
        super(params);
        this.mutable = params.mutable;
        this.exporttemplate = params.exporttemplate;
        this._data = params.exporttemplate.exportflow;
        this.objecttype = params.exporttemplate.objecttype;
        this.rulesets = params.rulesets;
        this.syncstep = params.exporttemplate.syncstep;
    }

    protected abstract data: KnockoutComputed<IExportFlowMutable[]>;

    private onAddClick() {
        this.createExportFlowMutable();
    }

    protected abstract createExportFlowMutable(): void;

    protected _createExportFlowMutable(inbound: boolean) {
        const flow = nsExportTemplate.createExportFlowMutable(inbound);
        this.mutable.trackFlowErrors(flow)
        this._data.push(flow);
    }

    onRemoveClick(item: IExportFlowMutable) {
        const index = this._data.indexOf(item);
        const undo = () => {
            this.mutable.trackFlowErrors(item);
            this._data.splice(index, 0, item);
        };

        global.snackbarData({
            message: `subject is removed|s:((attribute))`,
            undo: undo
        });
        this.mutable.untrackFlowErrors(item);
        this._data.remove(item);
    }

    isExportAttributeOrdinaryType(item: IExportAttribute): boolean {
        return nsExportTemplate.isExportAttributeOrdinaryType(item);
    }

    protected showButtons(type: 'standard' | 'exchange'): boolean {
        return false;
    }

    protected showSection(key: keyof IExportFlow): boolean {
        return true
    }

    override dispose() {
        this.kosub.unsuscribeAll();
    }
}
